var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"air_temperature_ship"}},[(_vm.receivedData)?_c('div',[_c('TabsCustomGraphic',{attrs:{"received-data":_vm.receivedData,"id":"air_temperature"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }